<app-resp-popup-title>
  <span i18n="@@PlanungAPI_FormularCreate_Title">Ein neues Formular erzeugen</span>
</app-resp-popup-title>
<app-resp-popup-content>
  @if (!isSaving) {
    <div class="container">
      <form [formGroup]="form">
        <frm-planung-form-template-select i18n-label="@@PlanungAPI_FormularCreate_Template" label="Template"
          formControlName="vorlageID" (selectionChange)="onVorlageChanged($event)"
        [includeReports]="true"></frm-planung-form-template-select>
        <frm-text i18n-label="@@PlanungAPI_FormularCreate_Description" label="Description" [multiline]="true"
        formControlName="beschreibung" rows="6"></frm-text>
      </form>
      <div class="preview">
        <div style="display: flex; justify-content: space-between">
          @if (reports.length > 1) {
            <ctrl-btn icon="navigate_before" [flat]="true"
            (click)="onPreviewBefore()"></ctrl-btn>
          } @else {
            <div></div>
          }
          <ctrl-btn icon="open_in_new" [iconPositionRight]="true" class="preview-title"
            [disabled]="!pdfSrc || pdfSrcLoading" [flat]="true" [content]="getLabelOfCurrentReportOrDefault()"
          (click)="onPreviewPopup()"></ctrl-btn>
          @if (reports.length > 1) {
            <ctrl-btn icon="navigate_next" [flat]="true"
            (click)="onPreviewNext()"></ctrl-btn>
          } @else {
            <div></div>
          }
        </div>
      </div>
      <cst-pdf-viewer [src]="pdfSrc" [textSelectable]="false" [loading]="pdfSrcLoading">
      </cst-pdf-viewer>
    </div>
  } @else {
    <app-shimmer [isLoading]="isLoading" type="custom">
      <div class="container">
        <div style="width: 360px">
          <app-shimmer-label></app-shimmer-label>
          <app-shimmer-input></app-shimmer-input>
          <app-shimmer-label></app-shimmer-label>
          <app-shimmer-input height="100px"></app-shimmer-input>
        </div>
        <div class="preview">
          <app-shimmer-label></app-shimmer-label>
          <div class="cst-pdf-viewer">
            <app-shimmer-input height="100%"></app-shimmer-input>
          </div>
        </div>
      </div>
    </app-shimmer>
  }
</app-resp-popup-content>
<app-resp-popup-actions>
  @if (!isSaving) {
    <ctrl-btn-accept [disabled]="!canAccept()" (click)="onAccept()"></ctrl-btn-accept>
    <ctrl-btn-cancel (click)="onCancel()"></ctrl-btn-cancel>
  } @else {
    <app-shimmer [isLoading]="isLoading" type="custom" style="width: 100%">
      <div style="display: inline-block; width: 140px;">
        <app-shimmer-button></app-shimmer-button>
      </div>
      <div style="display: inline-block; width: 140px;">
        <app-shimmer-button></app-shimmer-button>
      </div>
    </app-shimmer>
  }
</app-resp-popup-actions>


